import { Layout } from "widgets"
import { useContext, lazy, Suspense } from "react"
import { ImageButton, Loader } from "widgets"
import { belowViewPort } from "utils"
import { AppContext } from "./app-context-provider.js"
import orbitLogo from "images/orbit-logo.svg"
import phoneIcon from "icons/phone.svg"
import emailIcon from "icons/email.svg"
import hamburgerIcon from "icons/hamburger.svg"
import { colors } from "design"
import { useNavigate } from "react-router-dom"

const Profile = lazy(() => import("./profile.js"))

const Header = ({ onShowNavPanel, onCloseNavPanel }) => {
  const navigate = useNavigate()
  const { user } = useContext(AppContext)

  return (
    <Layout
      className="app-header"
      css={[
        {
          padding: "22px 20px",
          gap: 40,
          fontSize: "1rem",
          fontWeight: 500,
          // flexWrap: "wrap",
          flexShrink: 0,
          width: "100%",
          zIndex: 110,
          justifyContent: "space-between",
          flexWrap: "nowrap",
          color: colors.lightGrey100,
        },
        belowViewPort(768, {
          padding: 12,
          fontSize: "0.75rem",
        }),
      ]}
    >
      <Layout
        className="logo-container"
        css={[
          { flexGrow: 2, gap: 20 },
          belowViewPort(768, {
            flexGrow: 1,
          }),
          user && { flexGrow: "unset" },
        ]}
      >
        {user && (
          <ImageButton
            className="hamburger-button"
            alt="hamburger"
            title={t("form_header.refresh_tooltip")}
            icon={hamburgerIcon}
            onClick={onCloseNavPanel ?? onShowNavPanel}
            css={[
              { height: 26 },
              belowViewPort(1441, {
                width: "auto",
                height: 15,
              }),
            ]}
            iconStyle={{
              height: 26,
              ...belowViewPort(1441, {
                height: 15,
              }),
            }}
          />
        )}
        <ImageButton
          className="logo-button"
          alt="Resbird Technologies"
          icon={orbitLogo}
          css={[
            {
              width: "max-content",
              height: 41,
            },
            belowViewPort(425, {
              display: "none",
            }),
          ]}
          onClick={() => navigate("/")}
          iconStyle={{
            height: 41,
          }}
        />
      </Layout>
      {user && (
        <span
          className="agency-name"
          // css={belowViewPort(768, {
          //   display: "none",
          // })}
        >
          {user?.officeBasicDTO.officeName}
        </span>
      )}
      {user ? (
        <Suspense fallback={<Loader />}>
          <Profile />
        </Suspense>
      ) : (
        <>
          <Layout
            css={[
              { gap: 16 },
              belowViewPort(768, {
                display: "none",
              }),
            ]}
          >
            <img src={phoneIcon} className="phone-icon" />
            <div className="contact-number">{t("header.contact_no")}</div>
          </Layout>
          <Layout
            css={[
              { gap: 16 },
              belowViewPort(768, {
                display: "none",
              }),
            ]}
          >
            <img src={emailIcon} className="email-icon" />
            <div className="email">{t("header.support_email")}</div>
          </Layout>
        </>
      )}
    </Layout>
  )
}

export default Header
